<template>
   <div class="card-inter">
        <b-card-header v-on:click="changeAngel = !changeAngel"  header-tag="header" class=" w-100 h-100 p-0 colapseGreen mt-4 colapseGreen" role="tab">
            <div  v-b-toggle="i.toString() + '-tabinf' + name.replace(' ','')" variant="info" class="head-mes">
                <div class="title-left pl-3">
                <div class="title-colapse">{{name}}</div>
                </div>
                <div class="componente d-flex justify-content-end w-50">
                  <div class="mr-4 mt-2" style="color:white">{{countapr + ' Apartamento(s)'}}</div>
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel-white"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel-white"></i>
            </div>
            </div>
            </b-card-header>
            <b-collapse :id="i.toString() + '-tabinf' + name.replace(' ','')" :accordion="i.toString() + '-tabinf' + name.replace(' ','')" role="tabpanel">
            <b-card-body>
                   <div v-for="dat in dataTable" :key="dat.id">
                      <div class="row-colapse-green">
                        <p class="info-colapse-green">Apartamento {{ dat.unidade + ' - ' + dat.grupo }}</p>
                        <p class="info-colapse-green">{{dat.unidadeTipo.nome}}</p>
                        <p class="info-colapse-green">{{dat.posicao == 0 ? 'Sol da Manhã' : 'Sol da Tarde'}}</p>
                        <p class="info-colapse-green">{{dat.metro}} M²</p>
                        <p class="info-colapse-green">{{dat.unidadeTipo.suites}} suítes</p>
                        <p class="info-colapse-green">{{ getStatus(dat.disponibilidade) }}</p>
                        <i @click="edit(dat)" class="fas fa-pen pencil-edit"></i>
                    </div>
                    <hr>
                   </div>
            </b-card-body>
        </b-collapse>

          <b-modal
            hide-footer
            centered
            ref="authmodal"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            id="add-evolucao"
            :title="'EDITAR'"
          >
          <template #modal-title>
                <div class="header-title">EDITAR</div>
            </template>
            <div v-if="!newPlant">
                <div class="modal-body-cus">
                  <div class="d-flex">
                    <div class="col-md-4">
                      <label class="label-modal">Torre</label>
                      <select  v-model="dataEdit.grupo" class="form-control" id="exampleFormControlSelect1">
                        <option selected>{{dataEdit.grupo}}</option>
                        <option v-for="(dataop,i) in notGroup" :key="i" :value="dataop.group">{{dataop.group}}</option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label class="label-modal">Apartamento</label>
                      <input class="form-control" disabled v-model="dataEdit.nomeApartamento">
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex justify-content-between">
                        <label class="label-modal">Planta</label> <div @click="abrirNovaPlanta" class="d-flex newPlantAll"><div class="newPlatn mr-1"><i class="fas fa-plus-circle custom-icon"></i></div><span style="text-decoration: underline;">ADICIONAR PLANTA</span></div>
                      </div>
                      <select  @change="changePlant" v-model="dataEdit.unidadeId" class="form-control" id="exampleFormControlSelect1">
                        <option :value="dataEdit.unidadeId" selected>{{dataEdit.unidadeTipo == null ? 'Selecione uma Planta' : dataEdit.unidadeTipo.nome}}</option>
                        <option v-for="dataop in notType" :key="dataop.id" :value="dataop.id">{{dataop.nome}}</option>
                      </select>
                    </div>
                  </div>
                    <div class="d-flex pt-4">
                    <div class="col-md-4">
                      <label class="label-modal">Sol</label>
                      <select  v-model="dataEdit.posicao" class="form-control" id="exampleFormControlSelect1">
                        <option :value="dataEdit.posicao == 0 ? 0:1 " selected>{{dataEdit.posicao == 0 ? 'Sol da Manhã' : 'Sol da Tarde'}}</option>
                        <option :value="dataEdit.posicao == 0 ? 1:0">{{dataEdit.posicao == 0 ? 'Sol da Tarde' : 'Sol da Manhã'}}</option>

                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="label-modal">Tamanho</label>
                      <input :value="dataEdit.unidadeTipo == null ? '0 M²' : dataEdit.unidadeTipo.metragem + ' M²'" class="form-control" disabled>
                    </div>
                    <div class="col-md-2">
                      <label class="label-modal">Quartos</label>
                      <input :value="dataEdit.unidadeTipo == null ? '0 Suítes' : dataEdit.unidadeTipo.suites + ' Suítes'" class="form-control" disabled>
                    </div>
                    <div class="col-md-4">
                      <label class="label-modal">Disponibilidade</label>
                        <select v-model="dataEdit.disponibilidade" class="form-control" id="exampleFormControlSelect1">
                        <option :value="dataEdit.disponibilidade" selected>{{dataEdit.statusSelecionado}}</option>
                        <option v-for="(dataop,i) in getNotStatusData" :value="dataop.enum" :key="i">{{dataop == [] ? 'Teste' :dataop.descricao}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex  pt-5 justify-content-center">
                    <button @click="closeModal" class="btn-can w-25 mr-2">FECHAR</button>
                      <button class="btn-save w-25 ml-2"  @click="saveUnity">SALVAR</button>
                  </div>
                </div>
                </div>
          </b-modal>

          <b-modal
            hide-footer
            centered
             no-close-on-backdrop
            ref="authmodalNew"
            size="md"
            id="add-evolucao"
            :title="'Adicionar nova planta'"
          >
                <div>
                  <div class="newPlant-body-nova">
                    <div class="ajuste-label-planta">
                      <label class="label-new">Digite o nome da planta:</label>
                      <input v-model="namePlant" class="form-control w-100" placeholder="Digite o Nome">
                    </div>

                    <div class="d-flex  pt-5 justify-content">
                      <button @click="fecharNovaPlanta" class="btn-can largura mr-2">VOLTAR</button>
                      <button class="btn-save largura w-80 l-2" :disabled="btnNewPlant"  @click="savetype">SALVAR</button>
                    </div>

                  </div>
                </div>
          </b-modal>
   </div>
</template>

<script>
import Colapsetower from './colapsetower'
export default Colapsetower
</script>

<style scoped>
.justify-content{
  width: 100%;
  justify-content: center;
}
.largura{
  width: 40%;
}
.newPlant-body-nova{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem 1rem 0 1rem;
  height: fit-content;
}
.ajuste-label-planta{
  width: 100%;
}
.form-control{
  border-radius: 7px;
}
.row-colapse-green{
  display: flex;
  align-content: center;
  justify-content: space-between;
  width: 100%;
}
.btn-can{
  height: 40px;
  background: red;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.btn-can:hover{
  height: 40px;
  background: #be2b2b;;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}
.btn-save{
  height: 40px;
  background: #008148;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}

.btn-save:hover{
  height: 40px;
  background: #008147d7;
  color: white;
  border: none;
  font-weight: bold;
  border-radius: 10px;
}

.info-colapse-green{
  width: 20%;
  text-align: center;
}
.modal-header{
  display: none;
}
.newPlant-body{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 300px;
}
.label-new{
  font-size: 15px;
  font-weight: bold;
}
.close-modal-new{
  height: 40px;
  width: 40px;
  position: absolute;
  background: #A8A8A8;
  cursor: pointer;
  color: white;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 20px;
  top: 20px;
  border-radius: 50%;
}
.newPlatn{
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: green;
  color: white;
  display: flex;
  text-decoration: none !important;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.modal-head-cus{
  height: 70px;
  width: 100%;
  display: flex;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: white;
  font-weight: bold;
  background: #008144;
  position: relative;
}
.close-modal{
  position: absolute;
  height: 30px;
  width: 30px;
  background: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #008144;
  font-size: 18px;
  right: 10px;
  cursor: pointer;
}

.modal-body-cus{
  height: fit-content;
  padding: 1rem 0.5rem 0 0.5rem;
}
.btn-cancel{
  width: 270px;
  height: 50px;
  color: black;
  background: #DEDEDE;
  outline: none;
  font-size: 24px;

}
.newPlantAll{
  display: flex;
  align-items:center;
  font-size: 9px;
  font-weight: bold;
  color: #008144;
  cursor: pointer;
  font-family: 'Segoe UI';
}
.btn-cancel:hover{
  background: #dedededc;
}
.btn-salvar{
  width: 270px;
  height: 50px;
  background: #008144;
  color: white;
  border: none;
  font-size: 24px;
  outline: none;

}
.btn-salvar:disabled{
  background: gray;
  cursor: auto  ;
}
.btn-salvar:hover:not([disabled]){
  background: #008145e3;
}
.label-modal{
  font-size: 15px;
}

.colapseGreen{
    background-color: #008148;
    color: white;
    font-size: 20px;
    font-weight: bold;
}

.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.title-colapse{
  padding-left: 15px;
}

.head-mes{
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}

.componente{
  font-size: 15px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}

.arrow-angel-white{
  color: white;
  font-size: 30px;
  padding-right: 20px;
  padding-bottom: 8px;
}

.pencil-edit{
  font-size: 20px;
  color: green;
  cursor: pointer;
}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/colapsetower/colapsetower.vue